import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="w-full bg-blue-4 p-5 flex flex-col gap-10 select-none rounded-t-30">
      {/* Mapa */}
      <div className="relative w-full h-[350px] sm:h-[450px] lg:h-[550px] rounded-30 overflow-hidden">
        <h3 className="absolute right-1/2 top-5 translate-x-1/2 text-4xl sm:text-5xl lg:text-7xl font-bold text-blue-4 z-10 text-center">
          We are here!
        </h3>
        <iframe
          title="Brighton Centro de Inglés"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d249.3065194461788!2d-77.28439772590107!3d1.2264353108069967!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e2ed479b8e94a61%3A0x574a5914b75038a1!2sBrighton%20English%20Training%20Center!5e0!3m2!1sen!2sco!4v1727273497832!5m2!1sen!2sco"
          width="100%"
          height="100%"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      {/* Contenido */}
      <div className="flex flex-col lg:flex-row w-full items-center lg:items-center gap-8 lg:gap-5">
        {/* Logo */}
        <div className="w-full lg:w-1/3 text-center lg:text-left text-5xl sm:text-6xl lg:text-[90px] font-bold text-secundario">
          Brighton
        </div>

        {/* Links */}
        <div className="w-full lg:w-2/3 flex flex-col sm:flex-row justify-around text-white gap-8 sm:gap-5">
          {/* Columna 1 */}
          <div className="flex-grow">
            <p className="text-secundario font-bold text-lg sm:text-xl mb-3">
              Brighton
            </p>
            <ul className="space-y-1">
              <li className="hover:text-yellow-1 duration-200 text-sm">
                <Link to="cursos/bkids">Inglés para niños</Link>
              </li>
              <li className="hover:text-yellow-1 duration-200 text-sm">
                <Link to="/cursos">Cursos de Inglés</Link>
              </li>
              <li className="hover:text-yellow-1 duration-200 text-sm">
                <Link to="certificaciones">Exámenes de certificación</Link>
              </li>
              <li className="hover:text-yellow-1 duration-200 text-sm">
                <a href="https://sistema.brightonenglishcenter.edu.co/#/login">
                  Revisa tus notas en Simon
                </a>
              </li>
              <li className="hover:text-yellow-1 duration-200 text-sm">
                <a href="https://brightonenglishcenter.edu.co/verificacion/">
                  Verificación de Resultados APTIS
                </a>
              </li>
            </ul>
          </div>

          {/* Columna 2 */}
          <div className="flex-grow">
            <p className="text-secundario font-bold text-lg sm:text-xl mb-3">
              Nosotros
            </p>
            <ul className="space-y-1">
              <li className="hover:text-yellow-1 duration-200 text-sm">
                <a href="https://brightonenglishcenter.edu.co/portafolio/">
                  Portafolio
                </a>
              </li>
              <li className="hover:text-yellow-1 duration-200 text-sm">
                <Link to="/instructores">Profesores</Link>
              </li>
              <li className="hover:text-yellow-1 duration-200 text-sm">
                <Link to="/nosotros">Nosotros</Link>
              </li>
              <li className="hover:text-yellow-1 duration-200 text-sm">
                <Link to="/testimonios">Testimonios</Link>
              </li>
              <li className="hover:text-yellow-1 duration-200 text-sm">
                <Link to="/pqrfs">PQRFS</Link>
              </li>
            </ul>
          </div>

          {/* Columna 3 */}
          <div className="">
            <p className="text-secundario font-bold text-lg sm:text-xl mb-3">
              Telefonos
            </p>
            <ul className="space-y-1">
              <li>
                <li className="flex justify-between items-center">
                  <span className="w-1/2 text-sm">Academico</span>
                  <a
                    className="hover:text-yellow-1 duration-200 text-sm"
                    href="https://wa.link/xpeypz"
                    target="_blank"
                    rel="noreferrer"
                  >
                    +57 318 316 3984
                  </a>
                </li>
                <li className="flex justify-between items-center">
                  <span className="w-1/2 text-sm">Cursos de inglés</span>
                  <a
                    className="hover:text-yellow-1 duration-200 text-sm"
                    href="https://wa.link/eb9rut"
                    target="_blank"
                    rel="noreferrer"
                  >
                    +57 316 866 4459
                  </a>
                </li>
                <li className="flex justify-between items-center">
                  <span className="w-1/2 text-sm">Exámes de certificación</span>
                  <a
                    className="hover:text-yellow-1 duration-200 text-sm"
                    href="https://wa.link/6lldao"
                    target="_blank"
                    rel="noreferrer"
                  >
                    +57 318 528 9302
                  </a>
                </li>
                <li className="flex justify-between items-center">
                  <span className="w-1/2 text-sm">Teléfono fijo</span>
                  <a className="hover:text-yellow-1 duration-200 text-sm" href="tel:+576027210751">(602) 721 0751</a>
                </li>
              </li>
              <li className="my-4">
                <p className="text-secundario font-bold text-lg sm:text-xl">Escribenos</p>
              </li>
              <li className="hover:text-yellow-1 duration-200 hyphens-manual">
                <a href="mailto:contactos@brightonenglishcenter.edu.co">
                  contactos@brightonenglish&shy;center.edu.co
                </a>
              </li>
              <li className="flex justify-center sm:justify-start gap-5 py-5">
                <a href="https://www.facebook.com/BrightonPasto">
                  <i className="text-secundario fa-brands fa-facebook-f text-3xl sm:text-4xl lg:text-5xl hover:text-yellow-1 duration-200" />
                </a>
                <a
                  href="https://www.instagram.com/brightonpasto"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="text-secundario fa-brands fa-instagram text-3xl sm:text-4xl lg:text-5xl hover:text-yellow-1 duration-200" />
                </a>
                <a
                  href="https://www.tiktok.com/@brightonenglishcenterpso?_t=8q9oVimXZDR&_r=1"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="text-secundario fa-brands fa-tiktok text-3xl sm:text-4xl lg:text-5xl hover:text-yellow-1 duration-200" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
